<template>
  <div @click="handleClickInternal()" class="component_1">
    <h1>{{ msg }} {{ numClicks }}</h1>
  </div>
</template>

<script>
import EventBus from '../eventBus'
export default {
  name: 'Component1',
  mounted () {

  },
  data () {
    return {
      msg: 'Component 1',
      numClicks: 0
    }
  },
  methods: {
    handleClickInternal () {
      this.numClicks++
      EventBus.$emit('component_1_clicked', this.numClicks)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.component_1{
  background-color: brown;
}
h1, h2 {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Component1.vue